import React, { useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'language/i18n';
import { easySale } from 'models/source';
import { StatusContext } from 'contexts/statusContext';
import {
  TextInput, Checkbox, Form, Button, PhoneInput,
} from 'components/common';
import { USER_TYPE } from 'constants/common';
import { emailValidator, nameValidator } from 'utils/formValidators';

const ContactUsForm = ({ t }) => {
  const { setErrorState } = useContext(StatusContext);

  const [fullName, setFullName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [agreement, setAgreement] = useState(false);

  const [onResponse, setOnResponse] = useState(false);
  const [formRef, setFormRef] = useState(useRef());

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await easySale({
          fullName, company, email, phone, type: USER_TYPE.BUYER,
        });
        formRef.setFieldsValue({
          fullName: '', company: '', email: '', phone: '', agreement: false,
        });
        setFullName('');
        setCompany('');
        setEmail('');
        setPhone('+90');
        setAgreement(false);
        setErrorState({
          title: t('successful'),
          text: 'Talebiniz başarılı bir şekilde bize ulaşmıştır.',
          buttonText: t('close'),
          type: 'success',
          onClickButton: () => setErrorState({}),
        });
      } catch (error) {
        setErrorState({
          title: t('alert'),
          text: error.message,
          buttonText: t('close'),
          onClickButton: () => setErrorState({}),
        });
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFormSubmit}
      formRef={(ref) => setFormRef(ref)}
    >
      <div className="row">
        <div className="col-15 mb-3">
          <TextInput
            name="fullName"
            placeholder={t('fullName')}
            value={fullName}
            onChange={({ value }) => setFullName(value)}
            validator={nameValidator}
            required
          />
        </div>
        <div className="col-15 mt-3">
          <TextInput
            name="company"
            placeholder={t('company')}
            value={company}
            onChange={({ value }) => setCompany(value)}
            required
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <PhoneInput
            name="phone"
            label={t('phoneNumber')}
            value={phone}
            onChange={({ value }) => setPhone(value)}
            required
            mobileNumber
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col">
          <TextInput
            name="email"
            type="email"
            placeholder={t('email')}
            value={email}
            onChange={({ value }) => setEmail(value)}
            validator={emailValidator}
            required
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col">
          <Checkbox
            containerClassName="mb-4"
            name="agreement"
            value={agreement}
            onChange={({ value }) => setAgreement(value)}
            text="iyiMakina.com tarafından ileti gönderilmesini, bilgilerimin bu amaçla saklanmasını, kampanya ve tekliflerden yararlanmak için E-Posta, SMS vb. iletileri ve aramaları almayı,gönderime ilişkin hizmet alınan taraflarla paylaşılmasını haklarım saklı kalmak kaydı ile kabul ediyorum."
            required
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <Button
            htmlType="submit"
            className="im-button im-button--primary im-button--fluid im-button--center"
            label={t('send')}
            loading={onResponse}
          />
        </div>
      </div>
    </Form>
  );
};

ContactUsForm.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('common')(ContactUsForm);
